import { request } from "./http";

export interface EquityPoint {
  time: number;
  value: number;
}

export interface EquityCurve {
  trading_account_id: string;
  points: EquityPoint[];
}

export const equity = {
  curve: (tradingAccountId: string, fromTs?: string, toTs?: string) => {
    const p = new URLSearchParams({ trading_account_id: tradingAccountId });
    if (fromTs) p.set("from_ts", fromTs);
    if (toTs) p.set("to_ts", toTs);
    return request<EquityCurve>(`/api/v1/equity-curve?${p.toString()}`);
  },
};
